import { getApiUrl } from '../../utils/utils'

export const renewRefreshToken = async refreshToken => {
  if (!refreshToken) {
    throw new Error('refreshToken não fornecido.')
  }
  const url = `${getApiUrl()}v2/login/renewtoken`
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ refreshToken }),
  }

  try {
    const response = await fetch(url, config)
    const json = await response.json()
    return json
  } catch (error) {
    throw new Error(error)
  }
}

export const revokeRefreshToken = async email => {
  if (!email) {
    throw new Error('RevokeToken: E-mail não fornecido.')
  }
  const url = `${getApiUrl()}v2/login/signout`
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username: email }),
  }
  const response = await fetch(url, config)
  const json = await response.json()
  if (!response.ok) {
    throw new Error(json.Data)
  }
  return json
}
